// TypeScript Interface für Nutzer Entity (basierend auf Backend)
import { Kunde } from './kunde';

export enum Rolle {
  USER = 'USER',
  ADMIN = 'ADMIN'
}

export interface Nutzer {
  id: number;
  username: string;
  email: string;
  vorname: string;
  nachname: string;
  aktiv: boolean;
  rolle: Rolle;
  kunde: Kunde;
  erstelltAm: string;
  aktualisiertAm: string;
}

// Request Interface für neue Nutzer
export interface NutzerCreateRequest {
  username: string;
  email: string;
  vorname: string;
  nachname: string;
  password: string;
  rolle: Rolle;
  kunde: Kunde;
}

// Request Interface für Nutzer-Updates
export interface NutzerUpdateRequest {
  username?: string;
  email?: string;
  vorname?: string;
  nachname?: string;
  password?: string;
  aktiv?: boolean;
  rolle?: Rolle;
  kunde?: Kunde;
}

// Response Interface für paginierte Nutzer-Liste
export interface NutzerPageResponse {
  content: Nutzer[];
  pageable: {
    sort: {
      empty: boolean;
      sorted: boolean;
      unsorted: boolean;
    };
    offset: number;
    pageSize: number;
    pageNumber: number;
    paged: boolean;
    unpaged: boolean;
  };
  last: boolean;
  totalPages: number;
  totalElements: number;
  size: number;
  number: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  first: boolean;
  numberOfElements: number;
  empty: boolean;
}
